import script from "./EmailDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailDetailView.vue?vue&type=script&setup=true&lang=js"

import "./EmailDetailView.vue?vue&type=style&index=0&id=e050232c&lang=css"

const __exports__ = script;

export default __exports__